import { SiteDto } from '@dto';
import { StoreStatusEnum } from '@models';
import { getSiteBessStatus } from './store-status.helper';

export const getSiteColor = (site: SiteDto): string => {
  const controlMode = site.controlMode?.toLowerCase();
  const storeStatus = getSiteBessStatus(site.stores);
  if (controlMode === 'automaticoptimization' && storeStatus === StoreStatusEnum.RUNNING && site.online) {
    return 'allow';
  }
  if (controlMode === 'manual' || storeStatus === StoreStatusEnum.HOBBLED) {
    return 'warning';
  }
  return 'deny';
};
